<header>
    <div class="header-menu">
        <span (click)="toggleSideNav()" class="menu-icon material-icons">menu</span>
    </div>
</header>